import { Spin } from 'antd';
import classNames from 'classnames';
import parse from 'html-react-parser';
import useQuery from '../../../../util/useQuery';

export default function PreviewArticle({ detail, loading, lang, logo }) {
    const freeFormTopic = detail?.freeFormPolicy.freeFormPolicyNameTh;
    const freeFormTopicEn = detail?.freeFormPolicy.freeFormPolicyNameEn;
    const params = useQuery();
    return (
        <Spin spinning={loading}>
            <div
                className={classNames({
                    'rounded-md py-4 pl-4 pr-2 w-full border-1 max-w-4xl my-4 mx-auto bg-white':
                        !params.get('ember'),
                    'm-0 w-full !border-none ': params.get('ember') === '1',
                })}
                style={{ border: '1px solid #DBDBDB' }}
            >
                <div>
                    <div className="px-2">
                        <article className="prose max-w-full text-left">
                            <div className="text-center">
                            {detail?.freeFormPolicy.freeFormCompanyLogoId && (
                                    <img
                                        className="w-auto h-28 rounded-lg object-cover m-0"
                                        src={logo}
                                        alt={
                                            lang === 'en'
                                                ? freeFormTopicEn
                                                : freeFormTopic
                                        }
                                    />
                                )}
                                <h3>
                                    {lang === 'en'
                                        ? freeFormTopicEn
                                        : freeFormTopic}
                                </h3>
                                <p className="text-left indent-8">
                                    {lang === 'en'
                                        ?  parse(
                                            detail?.freeFormPolicy.freeFormIntroductionEn ||
                                                ''
                                        )
                                        : parse(
                                            detail?.freeFormPolicy.freeFormIntroductionTh ||
                                                ''
                                        )}
                                </p>
                            </div>

                            {detail?.freeFormDataList?.length > 0 &&
                                detail.freeFormDataList.map((item, index) => (
                                    <div
                                        key={item.freeFormTopicDataId || index}
                                    >
                                        <h4>
                                            {lang === 'en'
                                                ? item.freeFormTitleEn
                                                : item.freeFormTitleTh}
                                        </h4>
                                        {parse(
                                            `${
                                                lang === 'en'
                                                    ? item.freeFormContentEn
                                                    : item.freeFormContentTh ||
                                                      '-'
                                            }`
                                        )}
                                    </div>
                                ))}
                        </article>
                    </div>
                </div>
            </div>
        </Spin>
    );
}
